import React from 'react';
import AcquisitionOption from './AcquisitionOption';

import { useLocationContext } from '../../context/LocationContext';

export default function DeliveryOption() {
  const { isDeliveryAllowed = true } = useLocationContext();

  return isDeliveryAllowed ? (
    <AcquisitionOption
      title="delivery"
      text="Yay! Delivery is available in your location."
    />
  ) : null;
}
